import type { ReactNode } from 'react';
import { Divider, Stack } from '@mui/material';

/** The root sections of a document, one `DocumentSectionRow` each, separated by a thin rule. */
export function DocumentSectionList({ children }: { children: ReactNode }) {
  return (
    <Stack spacing={0} divider={<Divider sx={{ my: 0.5 }} />}>
      {children}
    </Stack>
  );
}
